module.exports = __webpack_public_path__ + "img/top6.19ac3fc8.png";